import { ResourceCategoryContext } from 'context'
import { sortBy } from 'lodash-es'
import { IDropdownOption } from 'office-ui-fabric-react'
import * as React from 'react'
import {
  AsyncDropdown,
  AsyncDropdownProps,
  FormikAsyncDropdownFactory,
} from '../AsyncDropdown'

export type ResourceCategoryDropdownProps = Omit<
  AsyncDropdownProps,
  'onResolveOptions'
>

export const ResourceCategoryDropdown: React.FunctionComponent<
  ResourceCategoryDropdownProps
> = ({ ...props }) => {
  const resourceCategories = React.useContext(ResourceCategoryContext)
  const resolveOptions: IDropdownOption[] = React.useMemo(() => {
    const options: IDropdownOption[] = resourceCategories.map((x) => ({
      key: x.id,
      text: x.title,
    }))
    return sortBy(options, 'text')
  }, [resourceCategories])

  return (
    <AsyncDropdown
      onResolveOptions={resolveOptions}
      placeholders={{ loading: 'Daten werden geladen...' }}
      {...props}
    />
  )
}

export type ResourceTypeDropdownProps = Omit<
  AsyncDropdownProps,
  'onResolveOptions'
> & { category: string }

export const ResourceTypeDropdown: React.FunctionComponent<
  ResourceTypeDropdownProps
> = ({ category, ...props }) => {
  const resourceCategories = React.useContext(ResourceCategoryContext)
  const resourceTypes = React.useMemo(() => {
    const resourceCategory = resourceCategories.filter(
      (x) => x.id === category
    )[0]
    return resourceCategory ? resourceCategory.types : []
  }, [resourceCategories, category])

  const resolveOptions: IDropdownOption[] = React.useMemo(() => {
    const options = resourceTypes.map(
      (x) =>
        ({
          key: x.id,
          text: x.title,
        } as IDropdownOption)
    )

    return sortBy(options, 'text')
  }, [resourceTypes])

  return (
    <AsyncDropdown
      onResolveOptions={resolveOptions}
      placeholders={{ loading: 'Daten werden geladen...' }}
      {...props}
    />
  )
}
export const FormikResourceCategoryDropdown = FormikAsyncDropdownFactory(
  ResourceCategoryDropdown
)
export const FormikResourceTypeDropdown =
  FormikAsyncDropdownFactory(ResourceTypeDropdown)
